import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'slider', 'price', 'gain'];
  static values = {
    gainMultiplier: Number,
    currency: String,
    locale: String,
  };

  connect() {
    Promise.all([import('nouislider'), import('nouislider/dist/nouislider.css')]).then(
      ([{ default: noUiSlider }]) => {
        this.budgetSlider = noUiSlider.create(this.sliderTarget, {
          start: [this.inputTarget.defaultValue || this.inputTarget.min],
          range: {
            min: parseFloat(this.inputTarget.min),
            max: parseFloat(this.inputTarget.max),
          },
          step: parseFloat(this.inputTarget.step),
          pips: {
            mode: 'count',
            values: 6,
            stepped: true,
            density: 20,
          },
          tooltips: {
            to: (value) => {
              return new Intl.NumberFormat(this.localeValue, {
                maximumFractionDigits: 0,
                useGrouping: 'min2',
              }).format(value);
            },
          },
          cssClasses: {
            ...noUiSlider.cssClasses,
            target: 'target noUi-slider-crave',
          },
        });

        this.budgetSlider.on('update', (values, handle) => {
          this.inputTarget.value = values[handle];
          this.inputTarget.dispatchEvent(new Event('change'));
        });

        // initial value formatting
        this.inputTarget.dispatchEvent(new Event('change'));
      },
    );
  }

  disconnect() {
    this.budgetSlider?.destroy();
  }

  update(e) {
    const value = parseFloat(e.target.value);
    this.priceTarget.textContent = new Intl.NumberFormat(this.localeValue, {
      style: 'currency',
      currency: this.currencyValue,
      maximumFractionDigits: 0,
      currencyDisplay: 'code',
      useGrouping: 'min2',
    }).format(value);
    this.gainTarget.textContent = new Intl.NumberFormat(this.localeValue, {
      useGrouping: 'min2',
      maximumFractionDigits: 0,
    }).format(value * this.gainMultiplierValue);
  }
}
